import { render } from "./Admincheckin.vue?vue&type=template&id=db1b7bde"
import script from "./Admincheckin.vue?vue&type=script&lang=js"
export * from "./Admincheckin.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__